import { render, staticRenderFns } from "./PaginationPostList.vue?vue&type=template&id=6b3fc22f"
import script from "./PaginationPostList.vue?vue&type=script&lang=js"
export * from "./PaginationPostList.vue?vue&type=script&lang=js"
import style0 from "./PaginationPostList.vue?vue&type=style&index=0&id=6b3fc22f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports